import { useDebouncedEffect } from "../../util/hooks";
import { storeObject } from "../../util/local-storage";

export function SaveData<T>(props: { data: T; storageKey: string }) {
  useDebouncedEffect(
    () => {
      storeObject(props.storageKey, props.data);
    },
    [props.data],
    1000
  );
  return null;
}
